var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.LinksList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var LinksList = function LinksList(_ref) {
    var children = _ref.children,
        className = _ref.className,
        legend = _ref.legend;
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: (0, _classnames.default)('next-links-list', className)
    }, legend && /*#__PURE__*/_react.default.createElement("li", {
      className: "next-links-list__legend"
    }, legend), children);
  };

  LinksList.propTypes = {
    className: _propTypes.default.string,
    legend: _propTypes.default.string,
    children: _propTypes.default.arrayOf(_propTypes.default.node).isRequired
  };
  LinksList.defaultProps = {
    className: '',
    legend: '',
    children: []
  };
  var _default = LinksList;
  _exports.default = _default;
});